import { apiFetch } from "./baseApi";

export function login({ email, password }) {
  return apiFetch("/authentication/login", {
    method: "POST",
    body: JSON.stringify({ email, password })
  });
}

export function signup({ displayName, email, password, confirmPassword }) {
  return apiFetch("/authentication/signup", {
    method: "POST",
    body: JSON.stringify({
      displayName,
      email,
      password,
      confirmPassword,
      isGoogle: false
    })
  });
}

export function googleLogin(code) {
  return apiFetch("/authentication/google-login", {
    method: "POST",
    body: JSON.stringify({ code }),
    signal: AbortSignal.timeout(25000)
  });
}

export function forgotPassword(email) {
  return apiFetch("/authentication/forgot-password", {
    method: "POST",
    body: JSON.stringify({ email })
  });
}

export function resetPassword(token, newPassword) {
  return apiFetch("/authentication/reset-password", {
    method: "POST",
    body: JSON.stringify({ token, newPassword })
  });
}

export function logout() {
  return apiFetch("/authentication/logout", {
    method: "POST"
  });
}

export function updateProfileField(payload) {
  return apiFetch("/authentication/profile/update", {
    method: "PATCH",
    body: JSON.stringify(payload)
  });
}

export function changePassword({ currentPassword, newPassword }) {
  return apiFetch("/authentication/change-password", {
    method: "POST",
    body: JSON.stringify({ currentPassword, newPassword })
  });
}